<template>
  <a-upload
    name="file"
            :multiple="false"
            :action="uploadUrl"
            :headers="headers"
            :before-upload="beforeUpload"
            @change="handleChange">
    <a-button>
      <a-icon type="upload" /> Click to Upload
    </a-button>
  </a-upload>
</template>
<script>

export default {
  name: 'WebsiteExcelUploader',
  data() {
    return {
      headers: {
        // authorization: 'authorization-text',
        token: localStorage.getItem('token'),
      },
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/website-import`,
    };
  },
  created() {
    this.keyImg = Math.random();
  },
  methods: {
    handleChange(info) {
      this.fileKey = Math.random();
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === 'done') {
        if (info.file.response.message === 'success') {
          window.localStorage.setItem('goods', JSON.stringify(info.file.response.data.goods));
          window.localStorage.setItem('goodsAttributeValue', JSON.stringify(info.file.response.data.goodsAttributeValue));
          window.localStorage.setItem('goodsSkuAttributeValue', JSON.stringify(info.file.response.data.goodsSkuAttributeValue));
          window.localStorage.setItem('goodsSKU', JSON.stringify(info.file.response.data.goodsSKU));
          this.$message.success(`${info.file.name} file uploaded successfully`);
        } else {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload xlsx file or csv file!');
      }
      return isJpgOrPng;
    },
  },
};
</script>
